/* eslint-disable no-console */
import { Configuration } from '@azure/msal-browser';
import { config } from './config';

const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const safari = ua.indexOf('Safari');
const firefox = ua.indexOf('Firefox');
const isIE = msie > 0 || msie11 > 0;
const isSafari = safari > 0;
const isFirefox = firefox > 0;

const {
  azureClientId: clientId,
  azureRedirectUri: redirectUri,
  azureUrl,
  azureTenant,
  azureAuthFlow,
} = config;

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
const authority = `${azureUrl}/${azureTenant}/${azureAuthFlow}`;

export const loginRequest = {
  scopes: ['openid'],
  redirectUri,
  authority,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const azure: Configuration = {
  auth: {
    clientId, // This is the ONLY mandatory field that you need to supply.
    authority, // Choose SUSI as your default authority.
    knownAuthorities: [authority], // Mark your B2C tenant's domain as trusted.
    redirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: isSafari || isIE || isFirefox, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
